import React from 'react';
import ExcelJS from 'exceljs';

interface Course {
  code: string;
  name: string;
  hours: number;
  credits: number;
  type: string;
  prerequisites: { code: string }[];
  status: string;
}

interface Cycle {
  term: string;
  courses: Course[];
}

interface Props {
  data: Cycle[];
}

const createHeaderRow = (worksheet: ExcelJS.Worksheet) => {
  worksheet.columns = [
    { header: 'Código Curso', key: 'code', width: 15 },
    { header: 'Nombre Curso', key: 'name', width: 40 },
    { header: 'Horas Semanales(*)', key: 'hours', width: 20 },
    { header: 'Créditos', key: 'credits', width: 15 },
    { header: 'Tipo', key: 'type', width: 15 },
    { header: 'Pre-Requisito', key: 'prerequisites', width: 20 },
    { header: 'Estado(***)', key: 'status', width: 15 }
  ];

  // Set background color for header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF74569E' } // Light gray background color
    };
  });
};

const addCycleData = (worksheet: ExcelJS.Worksheet, cycle: Cycle) => {
  worksheet.addRow([cycle.term]).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFADD8E6' } // Light blue background color
    };
  });

  cycle.courses.forEach((course) => {
    worksheet.addRow([
      course.code,
      course.name,
      course.hours,
      course.credits,
      course.type,
      course.prerequisites.map((prereq) => prereq.code).join(', '),
      course.status
    ]);
  });
};

const generateExcelFile = async (data: Cycle[]) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Plan de Estudio');

  createHeaderRow(worksheet);

  data.forEach((cycle) => {
    addCycleData(worksheet, cycle);
  });

  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();

  // Create a Blob from the buffer
  const blob = new Blob([buffer], { type: 'application/octet-stream' });

  // Create a temporary link element
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'Plan_de_Estudio.xlsx';

  // Simulate a click on the link to trigger the download
  link.click();

  // Clean up resources
  URL.revokeObjectURL(link.href);
};

const ExcelDocument: React.FC<Props> = ({ data }) => {
  const handleButtonClick = () => {
    generateExcelFile(data);
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleButtonClick}
        className="curriculum-downloader-li"
      >
        Versión en XLS
      </button>
    </div>
  );
};

export default ExcelDocument;
